import { Directive, ElementRef, Input, HostListener } from "@angular/core";

//Krupa Shah : Create directive to allow user to enter only numbers
@Directive({
    selector: '[NumberwithNegativeSign]'
  })

  export class NumberwithNegativeSign
  {
    inputElement: HTMLElement;
    constructor(private _el: ElementRef) { 
      this.inputElement = _el.nativeElement;
    }

    @Input() OnlyNumber: boolean;

    //listen on key down event to check and return only if entered value is number only
    @HostListener('keydown', ['$event']) onKeyDown(event) {
        let e = <KeyboardEvent> event;
        this.OnlyNumber = true;
        if (this.OnlyNumber) {          
          if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
            // Allow: home, end, left, right           
            (e.keyCode >= 35 && e.keyCode <= 39)) {
              // let it happen, don't do anything
              return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) && e.keyCode != 189 ) {
                e.preventDefault();
            }
          }
      }
      
      @HostListener('paste', ['$event']) onPaste(event) {
        // Don't allow pasted text that contains non-numerics
        var pastedText = (event.originalEvent || event).clipboardData.getData('text/plain');
      
        if (pastedText) {
          var regEx = new RegExp('^[0-9]*$');
          if (!regEx.test(pastedText)) {
            event.preventDefault();
          }
      }
    }
      @HostListener('drop', ['$event'])
      onDrop(event: DragEvent) {
        event.preventDefault();
        const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
        this.inputElement.focus();
        document.execCommand('insertText', false, textData);
      }
  }
